<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1000px"
      title="详情 订单信息"
      id-key="OrderId"
      :data="data"
      :save-func="()=>{}"
      form-label-width="110px"
      @edit-opened="onEditOpened"
      @closed="onClosed"
    >
      <template slot="form">
        <el-divider>订单内容</el-divider>
        <el-row>
          <el-col :span="8">
            <el-form-item label="订单编号">
              <span>{{data.OrderNo}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单时间">
              <span>{{this.$commonJs.toDateString(data.AddTime)}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单状态">
              <span>{{data.StatusText}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="发货状态">
              <span>{{data.SendStatusText}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款状态">
              <span>{{data.PayStatusText}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="退款状态">
              <span>{{data.RefundStatusText}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="联系人">
              <span>{{data.Person}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话">
              <span>{{data.Phone}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="配送方式">
              <span>{{data.FreightMode}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="收货地址">
              <span>{{data.Address}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="商品金额">
              <span>{{data.GoodsAmount}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="配送金额">
              <span>{{data.Freight}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="小计金额">
              <span>{{data.SubTotal}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="优惠券">
              <span v-if="data.CouponName">{{data.CouponName}}</span>
              <span v-else>无</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="优惠金额">
              <span>{{data.CouponAmount}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单总额">
              <span>{{data.Amount}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider>商品信息</el-divider>
        <el-table border :data="OrderGoods" style="width: 100%" size="mini">
          <el-table-column prop="GoodsName" label="商品名称" min-width="200px" />
          <el-table-column prop="Price" label="单价" min-width="110px" />
          <el-table-column prop="UnitName" label="单位" min-width="120px" />
          <el-table-column prop="Quantity" label="数量" min-width="100px" />
          <el-table-column prop="Amount" label="金额" min-width="120px" />
          <el-table-column prop="RetailPrice" label="活动" min-width="200px" />
        </el-table>
        <template v-if="data.SendStatus!=0">
          <el-divider>发货信息</el-divider>
          <el-table border :data="DeliverList" style="width: 100%" size="mini">
            <el-table-column prop="ExpressName" label="配送公司" min-width="200px" />
            <el-table-column prop="ExpressNo" label="配送单号" min-width="120px" />
            <el-table-column prop="AddTime" label="发货时间" min-width="150px" />
            <el-table-column prop="ActualFreight" label="实际配送金额" min-width="100px" />
          </el-table>
        </template>
        <template v-if="data.RefundStatus!=0">
          <el-divider>退款信息</el-divider>
          <el-row>
            <el-col :span="12">
              <el-form-item label="申请时间">
                <span>{{this.$commonJs.toDateString(data.ApplyTime)}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="data.RefundStatus>0">
              <el-form-item label="退款金额">
                <span>{{data.RefundAmount}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="退款原因">
                <span>{{data.Reason}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="24" v-if="data.SendStatus==0">
              <el-form-item label="商家反馈" prop="RefundStatus">
                <el-select size="mini" v-model="data.RefundStatus" placeholder="请选择商家反馈">
                  <el-option label="同意退款" :value="3"></el-option>
                  <el-option label="拒绝退款" :value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-else>
              <el-form-item label="商家反馈" prop="RefundStatus">
                <el-select size="mini" v-model="data.RefundStatus" placeholder="请选择商家反馈">
                  <el-option label="同意退款" :value="3"></el-option>
                  <el-option label="拒绝退款" :value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>-->
          <el-row v-if="data.SendStatus!=0">
            <el-col :span="24">
              <el-form-item label="商家备注">
                <span>{{data.Remark}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="data.SendStatus!=0">
            <el-col :span="8">
              <el-form-item label="退货配送公司">
                <span>{{data.BackExpressName}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="退货配送单号">
                <span>{{data.BackExpressNo}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="退货时间">
                <span>{{this.$commonJs.toDateString(data.BackTime)}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-if="data.RefundStatus>0">
          <el-divider>退货商品</el-divider>
          <el-table border :data="RefundList" style="width: 100%" size="mini">
            <el-table-column prop="GoodsName" label="商品名称" min-width="200px" />
            <el-table-column prop="Quantity" label="退货数量" />
            <el-table-column prop="Amount" label="退货金额" />
          </el-table>
        </template>
        <el-divider>操作日志</el-divider>
        <el-table border :data="OrderLog" style="width: 100%" size="mini">
          <el-table-column prop="Operator" label="操作者" min-width="110px" />
          <el-table-column prop="AddTime" label="操作时间" min-width="150px" />
          <el-table-column prop="Action" label="动作" min-width="80px" />
          <el-table-column prop="Status" label="订单状态" min-width="100px" />
          <el-table-column prop="SendStatus" label="发货状态" min-width="100px" />
          <el-table-column prop="PayStatus" label="付款状态" min-width="100px" />
          <el-table-column prop="Remark" label="操作备注" min-width="200px" show-overflow-tooltip />
        </el-table>
      </template>
      <template slot="footer">
        <template v-if="data.RefundStatus==1">
          <el-button size="mini" type="primary" @click="show1=true">同意退款</el-button>
          <el-button size="mini" type="danger" @click="show2=true">拒绝退款</el-button>
        </template>
        <el-button size="mini" type="primary" v-if="data.SendStatus==5" @click="receiveRefund">收货并退款</el-button>
        <el-button size="mini" @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <el-dialog title="同意退款" :visible.sync="show1" :before-close="beforeClose" width="30%">
      <el-form>
        <el-form-item label="商家反馈" label-width="75px" v-if="data.SendStatus==2">
          <el-select size="mini" v-model="Back" style="width: 300px;" placeholder="请选择商家反馈">
            <el-option label="同意申请，需用户填写退货信息并寄回" :value="true"></el-option>
            <el-option label="同意申请，商品无需寄回" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" :label-width="data.SendStatus==2?'75px':'50px'">
          <el-input type="textarea" v-model="BackRemark" style="width: 300px;" placeholder="请填写备注"></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer" class="dialog-footer">
        <el-button type="primary" @click="passRefund" size="mini">确 认</el-button>
        <el-button @click="show1 = false" size="mini">取 消</el-button>
      </template>
    </el-dialog>
    <el-dialog title="拒绝退款" :visible.sync="show2" :before-close="beforeClose" width="30%">
      <el-form>
        <el-form-item label="备注" label-width="50px">
          <el-input type="textarea" v-model="BackRemark" style="width: 300px;" placeholder="请填写备注"></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer" class="dialog-footer">
        <el-button type="primary" @click="refuseRefund" size="mini">确 认</el-button>
        <el-button @click="show2 = false" size="mini">取 消</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [detailsDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        OrderId: 0,
        OrderNo: "", //订单编号
        CustomerId: null, //客户编号
        CustomerName: "", //客户名称
        Mobile: "", //手机号
        CustomerType: null, //客户类型 - 1:零售
        GoodsAmount: null, //商品金额
        Quantity: null, //商品数量
        Amount: null, //订单金额
        PayAmount: null, //实付金额
        Point: null, //积分
        AddTime: null, //订单时间
        Status: null, //订单状态 - 0:未确认 1:正常执行中 2:退款中 3:已完成 4:已取消
        StatusText: "",
        SendStatus: null, //发货状态 - 0:未发货 1:部分发货 2:已发货 3:已收货 4:退货中 5:退货待收 6:已退货
        SendStatusText: "",
        PayStatus: null, //付款状态 - 0:未付款 1:已付款 2:退款中 3:已退款
        PayStatusText: "",
        RefundAmount: 0, //退款金额
        RefundStatus: null, //退款状态 - 0:无 1:退款待审 2:客户取消 3:同意退款 4:拒绝退款
        RefundStatusText: "",
        FreightMode: null, //配送方式 - 0:异地配送 1:本地配送 2:自提
        ExpressId: null, //配送公司编号
        ExpressName: "", //配送公司名称
        ExpressNo: "", //配送单号
        Freight: null, //配送金额
        SubTotal: null, //小计金额
        CouponName: "", //优惠券名称
        CouponAmount: null, //优惠金额
        Person: "", //收货联系人
        Phone: "", //收货联系电话
        Address: "", //收货地址
        Reason: "", //退款原因
        ApplyTime: null, //退款申请时间
        Feedback: "", //商家反馈
        Remark: "", //商家备注
        BackExpressName: "", //退货配送公司
        BackExpressNo: "", //退货配送单号
        BackTime: null, //退货时间
      },
      OrderGoods: [],
      OrderLog: [],
      DeliverList: [],
      RefundList: [], //退货商品
      show1: false,
      show2: false,
      isSave: false,
      BackRemark: "", //退款备注
      Back: true, //退款是否需要寄回商品
      api: require("@/api/mall/order").default,
      ogApi: require("@/api/mall/orderGoods").default,
      olApi: require("@/api/mall/orderLog").default,
      rgApi: require("@/api/mall/returnGoods").default,
    };
  },
  computed: {},
  methods: {
    onEditOpened(data) {
      this.Back = data.SendStatus == 2;
      // this.data.RefundStatus = null;
      var params = { OrderId: this.data.OrderId };
      this.ogApi.list(params).then((res) => {
        if (res.Data) this.OrderGoods = res.Data;
      });
      this.olApi.list(params).then((res) => {
        if (res.Data) this.OrderLog = res.Data;
      });
      this.api.getDeliverDocList(this.data.OrderId).then((res) => {
        if (res.Data) this.DeliverList = res.Data;
      });
      if (data.RefundStatus > 0) {
        this.rgApi.list(params).then((res) => {
          if (res.Data) this.RefundList = res.Data;
        });
      }
    },
    passRefund() {
      this.api
        .passRefund({
          OrderId: this.data.OrderId,
          Back: this.Back,
          Remark: this.BackRemark,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.show1 = false;
            this.close();
          } else {
            this.$message.error(res.Msg);
          }
        });
    },
    refuseRefund() {
      this.$confirm("确认拒绝退款吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api
            .refuseRefund({
              OrderId: this.data.OrderId,
              Remark: this.BackRemark,
            })
            .then((res) => {
              if (res.Code == 0) {
                this.$message.success(res.Msg);
                this.show2 = false;
                this.close();
              } else {
                this.$message.error(res.Msg);
              }
            });
        })
        .catch(() => {});
    },
    receiveRefund() {
      this.$confirm("确认收货并退款吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.backPass(this.data.OrderId).then((res) => {
            if (res.Code == 0) {
              this.$message.success("操作成功");
              this.close();
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch(() => {});
    },
    beforeClose() {
      this.BackRemark = "";
    },
    send() {
      // this.$refs.sendDialog.openCreate({ OrderId: this.data.OrderId });
    },
    setExpress(data) {
      this.api.getDeliverDocList(this.data.OrderId).then((res) => {
        this.DeliverList = [];
        res.Data.forEach((x) => {
          this.DeliverList.push(x);
        });
      });
      this.data.SendStatus = 2;
      this.data.SendStatusText = "已发货";
      this.isSave = true;
    },
    onClosed() {
      this.OrderGoods = [];
      this.OrderLog = [];
      this.DeliverList = [];
      this.RefundList = [];
      this.BackRemark = "";
      this.$emit("close-saved");
      if (this.isSave) {
        this.isSave = false;
      }
    },
  },
};
</script>